import { breakpoints } from '../../../resources/scripts/config/breakpoints';

function panelNativeAnimationInit(splitListAnimation) {
  const mainWrap = splitListAnimation.querySelector('.split-list__panels');
  const panelsWrapList = mainWrap.getElementsByClassName('split-list__panel');
  const panelsList = mainWrap.getElementsByClassName('split-list__panel-sticky');
  // const header = document.querySelector('header');
  const media = splitListAnimation.querySelector('.split-list__media');

  let heightArray = [];
  let widthArray = [];
  let offsetTopArray = [];
  let windowHeight = null;
  let windowWidth = null;
  let mainWrapHeight = null;
  let mainWrapOffsetTop = null;
  let resizeInProgress = false;

  const setSizes = () => {
    windowHeight = window.innerHeight;
    windowWidth = window.innerWidth;

    if (windowWidth >= breakpoints.lg) {
      [].forEach.call(panelsList, (el) => {
        const panel = el;
        panel.style.minHeight = '100vh';
      });
    }

    heightArray = [].map.call(panelsList, (panel) => panel.clientHeight);
    widthArray = [].map.call(panelsList, (panel) => panel.clientWidth);
    offsetTopArray = [].map.call(panelsWrapList, (el) => {
      const panel = el;
      return panel.getBoundingClientRect().top + window.scrollY;
    });
    [].forEach.call(panelsWrapList, (el, i) => {
      const panelWrap = el;
      panelWrap.style.height = `${heightArray[i]}px`;
    });
    [].forEach.call(panelsList, (el, i) => {
      const panel = el;
      panel.style.width = `${widthArray[i]}px`;
    });

    mainWrapHeight = mainWrap.clientHeight;
    mainWrapOffsetTop = mainWrap.getBoundingClientRect().top + window.scrollY;

    if (windowWidth >= breakpoints.lg) {
      media.style.top = 0;
      media.style.height = '100vh';
    }
  };

  setSizes();

  const clearSizes = () => {
    heightArray = [];
    widthArray = [];
    offsetTopArray = [];
    windowHeight = null;
    windowWidth = null;
    mainWrapHeight = null;
    mainWrapOffsetTop = null;
    [].forEach.call(panelsWrapList, (el) => {
      const panelWarp = el;
      panelWarp.style.height = 'auto';
      panelWarp.classList.remove('static');
    });
    [].forEach.call(panelsList, (el) => {
      const panel = el;
      panel.style.width = '100%';
      panel.style.minHeight = null;
      panel.classList.remove('fixed', 'fixed-bottom');
    });
    media.style.top = null;
    media.style.height = null;
  };

  function resizeDone() {
    setSizes();
    resizeInProgress = false;
  }

  let resizeTimeOut;
  let prevWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    const width = window.innerWidth;
    if (width !== prevWidth) {
      prevWidth = width;
      resizeInProgress = true;
      clearSizes();
      clearTimeout(resizeTimeOut);
      resizeTimeOut = setTimeout(resizeDone, 500);
    }

    windowHeight = window.innerHeight;
  });

  window.addEventListener('load', () => {
    clearSizes();
    resizeDone();
  });

  function handlePanels() {
    if (!widthArray.length) return;
    // if (!widthArray.length || windowWidth < breakpoints.lg) return;
    const windowScrollTop = window.scrollY;

    offsetTopArray.forEach((item, i) => {
      if (i === offsetTopArray.length - 1) {
        return;
      }
      const panel = panelsList[i];

      if (windowWidth < breakpoints.lg) {
        // mobile
        if (windowScrollTop + windowHeight >= offsetTopArray[i] + heightArray[i]) {
          panel.classList.add('fixed', 'fixed-bottom');
          panel.style.top = 'auto';
        } else {
          panel.classList.remove('fixed', 'fixed-bottom');
        }
        // mobile end
      }

      if (windowWidth >= breakpoints.lg) {
        // desktop
        if (windowScrollTop >= offsetTopArray[i]) {
          if (windowHeight < heightArray[i]) {
            if (windowScrollTop + windowHeight >= offsetTopArray[i] + heightArray[i]) {
              panel.classList.add('fixed', 'fixed-bottom');
              panel.style.top = 'auto';
            } else {
              panel.classList.remove('fixed', 'fixed-bottom');
            }
          } else {
            panel.classList.add('fixed');
            panel.style.top = 0;
          }
        } else {
          panel.classList.remove('fixed');
        }
        // desktop end
      }

      const multiply = windowHeight < heightArray[heightArray.length - 1] ? 0 : 1;
      const diffHeight = (heightArray[heightArray.length - 1] - windowHeight) * (multiply);
      const conditionOne = windowScrollTop + windowHeight + diffHeight;

      if (conditionOne >= mainWrapOffsetTop + mainWrapHeight) {
        panelsWrapList[i].classList.add('static');
        panel.classList.add('fixed-done');
        panel.style.top = 'auto';
      } else {
        panelsWrapList[i].classList.remove('static');
        panel.classList.remove('fixed-done');
      }
    });
  }

  function framePanels() {
    if (!resizeInProgress) {
      handlePanels();
    }
    requestAnimationFrame(framePanels);
  }
  requestAnimationFrame(framePanels);
}

function panelNativeAnimation() {
  const sectionList = document.getElementsByClassName('js_split-list__animation');
  [].forEach.call(sectionList, (sectionAnimation) => panelNativeAnimationInit(sectionAnimation));
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/slider', () => {
      panelNativeAnimation();
    });
  } else {
    panelNativeAnimation();
  }
});
